var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{model:{value:(_vm.tabName),callback:function ($$v) {_vm.tabName=$$v},expression:"tabName"}},_vm._l((_vm.tabs),function(t,i){return _c('el-tab-pane',{key:("tab-" + i),attrs:{"label":t,"name":("" + i)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }